<template>
  <span class="aepx-table-toolbar">
    <slot v-if="toolbarSlotPosition === 'left'" />
    <div v-if="advancedSearch" class="advancedSearch-btn-wrapper">
      <img v-show="!advancedSearchExpanded" src="../img/down arrow.png" :title="t('tableFilter.expand')" @click="handleAdvancedSearchExpanded(true)">
    </div>
    <slot v-if="toolbarSlotPosition === ''" />
    <el-button
      v-if="reset"
      size="small"
      icon="el-icon-refresh-left"
      circle
      :title="t('table.toolbar.reset')"
      @click="doReset"
    />
    <el-button
      v-if="refresh !== false"
      size="small"
      icon="el-icon-refresh"
      circle
      :title="t('table.toolbar.refreshTable')"
      @click="doRefresh"
    />
    <el-button
      v-if="exportExcel"
      size="small"
      icon="el-icon-download"
      circle
      :title="t('table.toolbar.exportExcel')"
      @click="doExportExcel"
    />
    <el-button
      v-if="sortObj.options && sortObj.options.length > 0"
      size="small"
      icon="el-icon-sort"
      circle
      :title="t('table.toolbar.combinationSort')"
      @click="doCombSort"
    />
    <el-button
      v-for="(item, index) in customBtns"
      :key="index"
      size="small"
      :type="item.type"
      :icon="item.icon"
      circle
      :title="item.title"
      @click="$emit('handleToolbarEmit', item.emit)"
    />
    <apex-color-picker
      v-if="mark"
      ref="apexColorPicker"
      :selection-rows="selectionRows"
      :row-key="mark"
      :storage="storage"
      :storage-need-prefix="storageNeedPrefix"
      title="Mark Row"
      @color-change="colorChange"
    />
    <el-button
      v-if="columns != null && columnsSetup !== false"
      type="primary"
      size="small"
      icon="el-icon-set-up"
      circle
      :title="t('table.toolbar.columnsSetup')"
      @click="doColumnsFilter"
    />

    <table-columns-filter
      v-if="columns != null && columnsSetup !== false"
      ref="columnsSetup"
      v-model="columnsFilter.value"
      :options="columnsFilter.options"
      :storage="storage"
      :storage-need-prefix="storageNeedPrefix"
      :disabled-fixed="disabledFixed"
      :disabled-sort="disabledSort"
      @change="handleColumnsFilterChanged"
    />
    <apex-comb-sort
      v-if="sortObj.options && sortObj.options.length > 0"
      ref="apexCombSort"
      v-model="sortObj.value"
      :options="sortObj.options"
      :storage="storage"
      :storage-need-prefix="storageNeedPrefix"
      @change="handleCombSortChange"
    />
    <slot v-if="toolbarSlotPosition === 'right'" />
  </span>
</template>

<script>
import locale from '@/mixins/index'
import tableColumnsFilter from './apex-table-columns-filter'
import apexColorPicker from './apex-color-picker'
import apexCombSort from './apex-comb-sort'
import _clonedeep from 'lodash.clonedeep'

export default {
  name: 'ApexToolbar',
  components: { tableColumnsFilter, apexColorPicker, apexCombSort },
  mixins: [locale],
  props: {
    /**
     * 是否显示重置搜索条件按钮
     */
    reset: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示刷新
     */
    refresh: {
      type: Boolean,
      default: true
    },
    /**
     * 是否显示导出按钮
     */
    exportExcel: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示高级搜索
     */
    advancedSearch: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示列设置按钮
     */
    columnsSetup: {
      type: Boolean,
      default: true
    },
    /**
     * 禁用列左右固定
     */
    disabledFixed: {
      type: Boolean,
      default: false
    },
    /**
     * 禁用列排序
     */
    disabledSort: {
      type: Boolean,
      default: false
    },
    /**
     * 列配置
     */
    columns: {
      type: Array,
      default: undefined
    },
    /**
     * 是否缓存
     * 传string则表示传入缓存的主key
     */
    storage: {
      type: [Boolean, String],
      default: true
    },
    /**
     * 缓存名字是否需要路由前缀名称
     */
    storageNeedPrefix: {
      type: Boolean,
      default: true
    },
    /**
     * 是否开启mark行
     * 传string则表示行的主键
     */
    mark: {
      type: String,
      default: ''
    },
    // 多选行数据
    selectionRows: {
      type: Array,
      default: () => []
    },
    // 自定义按钮
    customBtns: {
      type: Array,
      default: () => []
    },
    // 是否启用列宽宽度持久化   注意：必须和columnsSetup一起使用
    resizable: {
      type: Boolean,
      default: true
    },
    // 高级查询展开折叠状态
    advancedSearchExpanded: {
      type: Boolean,
      default: false
    },
    // toolbar插槽的位置
    toolbarSlotPosition: {
      type: String,
      default: ''
    },
    // 组合排序自定义列
    combSortList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columnsFilter: {
        value: [],
        options: []
      },
      sortObj: {
        value: [],
        options: []
      }
    }
  },
  created() {
    this.columnsFilter.options = _clonedeep(this.columns)
    this.columnsFilter.value = _clonedeep(this.columns)
    let finalCombSortList = this.columns.filter(item => item.combSort).map(item2 => {
      return {
        title: item2.combSort.title || item2.title,
        key: item2.combSort.key || item2.key,
        orderBy: item2.combSort.orderBy || ''
      }
    })
    if (this.combSortList && this.combSortList.length > 0) {
      finalCombSortList = this.combSortList
    }
    this.setCombSortList(finalCombSortList)
  },
  methods: {
    doResizable(newWidth, oldWidth, column) {
      if (this.resizable) {
        this.$refs.columnsSetup.doResizable(newWidth, oldWidth, column)
      }
    },
    doRefresh() {
      this.$emit('refresh')
    },
    doReset() {
      this.$emit('reset')
    },
    doExportExcel() {
      this.$emit('exportExcel', null)
    },
    doColumnsFilter() {
      this.$refs.columnsSetup.start()
    },
    doCombSort() {
      this.$refs.apexCombSort.start()
    },
    handleColumnsFilterChanged(columns) {
      this.$emit('columns-filter-changed', columns)
    },
    handleCombSortChange(sortList, changeType) {
      this.$emit('comb-sort-change', sortList, changeType)
    },
    colorChange(color, rows) {
      this.$emit('color-change', color, rows)
    },
    handleAdvancedSearchExpanded(expanded) {
      this.$emit('handleAdvancedSearchExpanded', expanded)
    },
    setCombSortList(list) {
      this.sortObj.options = _clonedeep(list)
      this.sortObj.value = _clonedeep(list)
    }
  }
}
</script>
<style lang="scss">
.aepx-table-toolbar {
  float: right;
}
.advancedSearch-btn-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.apex-button {
  &.is-thin {
    &.el-button--small,
    &.el-button--small.is-round {
      padding: 9px 9px;
    }
    &.el-button--mini,
    &.el-button--mini.is-round {
      padding: 7px 7px;
    }
  }
}
</style>
